import styles from './card.module.css';
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { getBackgroundColor, getTextColor, get80BackgroundColor } from '../../../code/ColorHandler';
import { Icons } from '../../../code/IconHandler';
const Card = ({ id, children, icon, iconText, onIconClick, title, rightText, isOpen: isOpenProp, setIsOpen: setIsOpenProp }) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const isControlled = isOpenProp !== undefined && setIsOpenProp !== undefined;

    const isOpen = isControlled ? isOpenProp : internalOpen;
    const setIsOpen = isControlled ? setIsOpenProp : setInternalOpen;
    const location = useLocation();
    useEffect(() => {
        const hashId = location.hash.replace('#', '');
        if (hashId === id) {
            if (!id) return;
            setIsOpen(true);
            // Optionally, scroll the card into view
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location.hash, id, setIsOpen]);
    return (
        <div id={id || undefined} tabIndex={0} className={styles.card}
            onKeyDown={(e) => {
                // Only toggle if the focused element is the card itself
                if ((e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
                    e.preventDefault();
                    setIsOpen(!isOpen);
                }
            }}

            style={{ backgroundColor: getBackgroundColor(location) }}
        >
            <div
                className={styles.top}
                onClick={() => setIsOpen(!isOpen)}
                style={{ backgroundColor: getBackgroundColor(location) }}
            >
                <div className={styles.left}>
                    {icon && (<img className={styles.icon} src={icon} alt={iconText ? iconText : 'Bild/Icon welches zum Thema passt'} onClick={(e) => {
                        e.stopPropagation();  // Prevent the card toggle
                        if (onIconClick) onIconClick();
                    }}
                        style={{ cursor: onIconClick ? 'pointer' : 'default' }}
                    />)}
                    <h3 className={styles.title}
                        style={{ color: getTextColor(location) }}
                    >{title}</h3>
                </div>

                <div className={styles.right}>
                    {rightText && (
                        <p className={styles.rightText}
                            style={{ color: getTextColor(location) }}
                        >
                            {rightText}
                        </p>)}
                    <Icons.ArrowRight
                        className={`${styles.gt} ${isOpen ? styles.rotated : ""}`}
                        style={{ cursor: "pointer", fill: getTextColor(location) }}
                    />
                </div>
            </div>
            <div
                className={`${styles.content} ${isOpen ? styles.show : styles.hide}`}
                style={{ backgroundColor: get80BackgroundColor(location) }}
            >
                {/* Prefer children if present; otherwise fall back to legacy `div` */}
                {children && (children)}
            </div>
        </div >
    );
}

export default Card;